import { render, staticRenderFns } from "./TemplateDescription.vue?vue&type=template&id=6825fac6&"
import script from "./TemplateDescription.vue?vue&type=script&lang=js&"
export * from "./TemplateDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports